module.exports = __webpack_public_path__ + "static/media/online_safety_checklist-CH_combine2.2942bfab.pdf";